import { render, staticRenderFns } from "./SalonStylistReview.vue?vue&type=template&id=236dbf82"
import script from "./SalonStylistReview.vue?vue&type=script&lang=js"
export * from "./SalonStylistReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports